import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Range } from "react-range";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Carousel from "react-multi-carousel";
import Footer from "../components/Footer";
import Categorys from "../components/Categorys";
import Products from "../components/products/Products";
import SEO from "../components/SEO";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import NoProductsMessage from "../components/NoProductsMessage";
import ProductsLoader from "../components/ProductsLoader";
import {
  price_range_product,
  query_products,
  setLoading,
  setSearching,
  get_category,
} from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";

const CategoryShops = ({ sellerId, sellerName }) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const {
    products,
    totalProduct,
    latest_product,
    priceRange,
    parPage,
    banners,
    isLoading,
    isSearching,
  } = useSelector((state) => state.home);

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [filter, setFilter] = useState(true);
  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRatingQ] = useState("");
  const [sortPrice, setSortPrice] = useState("high-to-low");
  const [currencySymbol, setCurrencySymbol] = useState("");

  // Set document title
  useEffect(() => {
    document.title = "4POS eCommerce Customer";
  }, []);

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(price_range_product(sellerId));
    dispatch(get_category(sellerId));
  }, [dispatch, sellerId]);

  useEffect(() => {
    setState({
      values: [
        priceRange.low,
        priceRange.high === priceRange.low
          ? priceRange.high + 1
          : priceRange.high,
      ],
    });
  }, [priceRange]);

  useEffect(() => {
    if (latest_product && latest_product.length > 0) {
      const symbol = latest_product[0][0].currency || "";
      setCurrencySymbol(symbol);
    }
  }, [latest_product]);

  useEffect(() => {
    if (priceRange.low > 0) {
      dispatch(setSearching(true));
      dispatch(
        query_products({
          sellerId: sellerId,
          query: {
            low: state.values[0] || "",
            high: state.values[1] || "",
            category: category ? decodeURIComponent(category) : "",
            rating,
            sortPrice,
            pageNumber,
          }
        })
      );
    }
  }, [
    state.values[0],
    state.values[1],
    category,
    rating,
    pageNumber,
    sortPrice,
  ]);

  const resetRating = () => {
    setRatingQ("");
    dispatch(setSearching(true));
    dispatch(
      query_products({
        sellerId: sellerId,
        query: {
          low: state.values[0],
          high: state.values[1],
          category,
          rating: "",
          sortPrice,
            pageNumber,
        },
      })
    );
  };
    const responsiveBanner = {
      superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
    };




  return (
    <>
      <SEO
        title={category ? `${category} Products - ${sellerName} | 4POS eCommerce` : `All Products - ${sellerName} | 4POS eCommerce`}
        description={category ? `Browse ${category} products at ${sellerName}. Quality products, great prices, and fast shipping.` : `Shop all products at ${sellerName}. Discover amazing deals and quality products.`}
        keywords={`${category || 'products'}, ${sellerName}, online shopping, ecommerce, ${category || 'all products'}`}
        url={window.location.href}
        type="website"
        breadcrumbs={[
          { name: "Home", url: `/${sellerName}` },
          { name: category || "All Products", url: window.location.href }
        ]}
      />
      <Headers sellerId={sellerId} sellerName={sellerName} />
      <section className="h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left">
        <Carousel
          autoPlay={true}
          infinite={true}
          arrows={false}
          showDots={false}
          responsive={responsiveBanner}
          className="h-full"
        >
          {banners &&
            banners.length > 0 &&
            banners.map((b, i) => (
              <div key={i} className="h-full w-full">
                <img
                  className="w-full h-full object-cover"
                  src={b.banner}
                  alt=""
                />
              </div>
            ))}
        </Carousel>
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <div className="flex items-center gap-2 text-white mb-2">
                <Link to={`/${sellerName}`} className="hover:text-indigo-300">Home</Link>
                <MdOutlineKeyboardArrowRight />
                <span>{category ? decodeURIComponent(category) : "All Products"}</span>
              </div>
              <h2 className="text-3xl font-bold">
                {category ? `${decodeURIComponent(category)} Products` : "All Products"}
              </h2>
            </div>
          </div>
        </div>
      </section>
      
      {/* Category Section */}
      <div className="my-4">
        <Categorys sellerId={sellerId} sellerName={sellerName} />
      </div>
      
      <section className="py-16">
        <div className="w-[85%] md:w-[90%%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">
              {category ? `${decodeURIComponent(category)} Products` : "All Products"}
            </h1>
            <p className="text-gray-600">
              {category 
                ? `Browse all products in the ${decodeURIComponent(category)} category`
                : "Discover our complete collection of products"
              }
            </p>
          </div>
          <div className={`md:block hidden ${!filter ? "mb-6" : "mb-0"}`}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center w-full py-2 px-3 bg-indigo-500 text-white"
            >
              Filter Product
            </button>
          </div>
          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${
                filter
                  ? "md:h-0 md:overflow-hidden md:mb-6"
                  : "md:h-auto md:overflow-auto md:mb-0"
              }`}
            >
              <div className="py-2 flex flex-col gap-6">
                <div>
                  <h2 className="text-2xl font-bold mb-2 text-gray-800">
                    Price Range (High to Low)
                  </h2>
                  <p className="text-sm text-gray-600">
                    Drag the handles to set your price range from high to low
                  </p>
                </div>
                
                <div className="space-y-4">
                  <Range
                    step={1}
                    min={priceRange.low}
                    max={
                      priceRange.high === priceRange.low
                        ? priceRange.high + 1
                        : priceRange.high
                    }
                    values={state.values}
                    onChange={(values) => {
                      setState({ values });
                      dispatch(setSearching(true));
                    }}
                    renderTrack={({ props, children }) => (
                      <div
                        {...props}
                        className="w-full h-[8px] bg-gray-200 rounded-full cursor-pointer relative"
                        style={{
                          background: `linear-gradient(to right, #e5e7eb 0%, #3b82f6 0%, #3b82f6 100%, #e5e7eb 100%)`
                        }}
                      >
                        {children}
                      </div>
                    )}
                    renderThumb={({ props, isDragged }) => (
                      <div
                        className={`w-6 h-6 bg-white border-2 border-indigo-500 rounded-full shadow-lg cursor-pointer transform transition-all duration-200 ${
                          isDragged ? 'scale-110 shadow-xl' : 'hover:scale-105'
                        }`}
                        {...props}
                      />
                    )}
                  />

                  <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg">
                    <div className="text-center">
                      <p className="text-xs text-gray-500 mb-1">High Price</p>
                      <p className="text-lg font-bold text-indigo-600">
                        {currencySymbol}{Math.floor(state.values[1])}
                      </p>
                    </div>
                    <div className="text-gray-400 text-2xl">↓</div>
                    <div className="text-center">
                      <p className="text-xs text-gray-500 mb-1">Low Price</p>
                      <p className="text-lg font-bold text-indigo-600">
                        {currencySymbol}{Math.floor(state.values[0])}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-center">
                    <button
                      onClick={() => {
                        const newValues = [priceRange.low, priceRange.high === priceRange.low ? priceRange.high + 1 : priceRange.high];
                        setState({ values: newValues });
                        dispatch(setSearching(true));
                        dispatch(
                          query_products({
                            sellerId: sellerId,
                            query: {
                              low: newValues[0],
                              high: newValues[1],
                              category: category ? decodeURIComponent(category) : "",
                              rating,
                              sortPrice,
                              pageNumber,
                            }
                          })
                        );
                      }}
                      className="px-6 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors duration-200"
                    >
                      Reset Price Range
                    </button>
                  </div>
                </div>
              </div>
              {/* Rating filter section hidden */}
              {/* <div className="py-3 flex flex-col gap-4">
                <h2 className="text-3xl font-bold mb-3 text-slate-600">
                  Rating
                </h2>
                <div className="flex flex-col gap-3">
                  <div
                    onClick={() => setRatingQ(5)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                  </div>
                  <div
                    onClick={() => setRatingQ(4)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => setRatingQ(3)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => setRatingQ(2)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => setRatingQ(1)}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={resetRating}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                </div>
              </div> */}
              {/* <div className="py-5 flex flex-col gap-4 md:hidden">
              
                <Products
                  title="Latest Products"
                  products={latest_product}
                  sellerId={sellerId}
                />
              </div> */}
            </div>
            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className="pl-8 md:pl-0">
                <div className="py-4 bg-white mb-10 px-3 rounded-md flex justify-between items-start border">
                  <h2 className="text-lg font-medium text-slate-600">
                    {totalProduct} Products
                  </h2>
                  {totalProduct > 0 && (
                    <div className="flex justify-center items-center gap-3">
                      <select
                        onChange={(e) => {
                          setSortPrice(e.target.value);
                          dispatch(setSearching(true));
                        }}
                        className="p-1 border outline-0 text-slate-600 font-semibold"
                        name=""
                        id=""
                        value={sortPrice}
                      >
                        <option value="high-to-low">High to Low Price</option>
                        <option value="low-to-high">Low to High Price</option>
                      </select>
                      <div className="flex justify-center items-start gap-4 md-lg:hidden">
                        <div
                          onClick={() => setStyles("grid")}
                          className={`p-2 ${
                            styles === "grid" && "bg-slate-300"
                          } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                        >
                          <BsFillGridFill />
                        </div>
                        <div
                          onClick={() => setStyles("list")}
                          className={`p-2 ${
                            styles === "list" && "bg-slate-300"
                          } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                        >
                          <FaThList />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="pb-8">
                  {isLoading ? (
                    <ProductsLoader isInitialLoad={true} />
                  ) : isSearching ? (
                    <ProductsLoader isInitialLoad={false} />
                  ) : !products || products.length === 0 ? (
                    <NoProductsMessage 
                      title="No Products Found"
                      message="We couldn't find any products in this category matching your criteria."
                      suggestions={[
                        "Adjusting the price range",
                        "Removing the rating filter",
                        "Checking a different price range",
                        "Clearing all filters"
                      ]}
                    />
                  ) : (
                    <ShopProducts
                      products={products}
                      styles={styles}
                      sellerId={sellerId}
                      sellerName={sellerName}
                    />
                  )}
                </div>
                {totalProduct > parPage && (
                  <div>
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer sellerId={sellerId} sellerName={sellerName} />
    </>
  );
};

export default CategoryShops;